import {createActions} from 'reduxsauce';

export const {Types: WichListTypes, Creators: WichListActionCreators} = createActions ({
    wichListUpdate: ['data'],
});
